import { generateOFlowCanvasEdgeId, generateOFlowCanvasGroupId, generateOFlowCanvasNodeId, } from './../utils';
import { BaseEdge } from '../canvas/element/edge/common';
import { CanvasModel } from './canvas-model';
import { isUndefined, isEqual } from 'lodash';
export * from './canvas-model';
export * from './interface';
export * from './common';
export class OFlowModel {
    static buildModel(oFlowId, callback) {
        if (!this.oFlowIdConfigModelMap[oFlowId]) {
            this.oFlowIdConfigModelMap[oFlowId] = new OFlowModel({ oFlowId });
            callback === null || callback === void 0 ? void 0 : callback();
        }
    }
    static getModel(oFlowId) {
        return this.oFlowIdConfigModelMap[oFlowId];
    }
    static destroyModel(oFlowId) {
        const canvasModelMap = this.oFlowIdConfigModelMap[oFlowId].canvasIdModelMap;
        Object.keys(canvasModelMap).forEach(key => {
            canvasModelMap[key].setCanvasData({});
            delete canvasModelMap[key];
        });
        delete this.oFlowIdConfigModelMap[oFlowId];
    }
    buildCanvasModel({ canvasId, canvas, canvasData = { nodes: [], edges: [], groups: [] }, rankConfig = {}, }) {
        if (!this.canvasIdModelMap[canvasId]) {
            this.canvasIdModelMap[canvasId] = new CanvasModel({
                canvasId,
                canvas,
                oFlowModel: this,
                canvasData,
                rankConfig,
            });
        }
        // 绑定时，进行设置
        this.setActiveCanvasId(canvasId);
        return this.canvasIdModelMap[canvasId];
    }
    getActiveCanvasModel() {
        return this.canvasIdModelMap[this.activeCanvasId];
    }
    getCanvasModel(canvasId) {
        return this.canvasIdModelMap[canvasId];
    }
    on(key, func) {
        this[`${key}_LISTENERS`].push(func);
    }
    off(key, func) {
        const idx = this[`${key}_LISTENERS`].findIndex(i => i === func);
        this[`${key}_LISTENERS`].splice(idx, 1);
    }
    trigger(key, activeCanvasId) {
        this[`${key}_LISTENERS`].forEach(func => {
            func(activeCanvasId);
        });
    }
    getOFlowId() {
        return this.oFlowId;
    }
    // 是否时多Tab模式
    get isMutipleTabMode() {
        return !isUndefined(this.tabsCanvasData);
    }
    constructor({ oFlowId }) {
        this.generateOFlowCanvasNodeId = generateOFlowCanvasNodeId;
        this.generateOFlowCanvasEdgeId = generateOFlowCanvasEdgeId;
        this.generateOFlowCanvasGroupId = generateOFlowCanvasGroupId;
        this.overrideGenerateId = (type, fn) => {
            if (type === 'NODE')
                this.generateOFlowCanvasNodeId = fn;
            if (type === 'EDGE')
                this.generateOFlowCanvasEdgeId = fn;
            if (type === 'GROUP')
                this.generateOFlowCanvasGroupId = fn;
        };
        this.ACTIVE_CANVAS_CHANGE_LISTENERS = [];
        this.setActiveCanvasId = (activeCanvasId) => {
            if (activeCanvasId === this.activeCanvasId)
                return;
            this.activeCanvasId = activeCanvasId;
            this.trigger('ACTIVE_CANVAS_CHANGE', activeCanvasId);
        };
        this.editable = true;
        this.zoomable = true;
        // model的map
        this.canvasIdModelMap = {};
        // 布局类型
        this.layoutType = 'VERTICAL';
        this.getLayoutType = () => {
            return this.layoutType;
        };
        this.setLayoutType = (layoutType) => {
            this.layoutType = layoutType;
        };
        // 设置data
        this.setTabsCanvasData = (data) => {
            this.tabsCanvasData = data;
        };
        /**
         *  注册节点、连线、组类型
         */
        this.nodeTypeMap = {};
        this.edgeTypeMap = { BaseEdge };
        this.groupTypeMap = {};
        this.setEditable = editable => {
            this.editable = editable;
        };
        this.setZoomable = zoomable => {
            this.zoomable = zoomable;
        };
        this.getZoomable = () => {
            return this.zoomable;
        };
        this.getEditable = () => {
            return this.editable;
        };
        // 注册节点
        this.registerNodeType = (config = {}) => {
            Object.assign(this.nodeTypeMap, config);
            this.triggerTypeChange();
        };
        // 注册连线
        this.registerBaseEdge = (BizBaseEdge) => {
            Object.assign(this.edgeTypeMap, { BaseEdge: BizBaseEdge });
            this.triggerTypeChange();
        };
        // 注册组
        this.registerGroupType = (config = {}) => {
            Object.assign(this.groupTypeMap, config);
            this.triggerTypeChange();
        };
        this.typeListenerList = [];
        this.triggerTypeChange = () => {
            var _a;
            (_a = this.typeListenerList) === null || _a === void 0 ? void 0 : _a.forEach(fn => fn === null || fn === void 0 ? void 0 : fn());
        };
        this.onRegisterTypeChange = fn => {
            this.typeListenerList.push(fn);
        };
        this.offRegisterTypeChange = fn => {
            var _a;
            const idx = (_a = this.typeListenerList) === null || _a === void 0 ? void 0 : _a.findIndex(item => item === fn);
            this.typeListenerList.splice(idx, 1);
        };
        this.getCommandPreviousHooks = (commandType) => {
            const key = `PREVIOUS_${commandType}`;
            return this[key] || [];
        };
        this.getCommandPostHooks = (commandType) => {
            const key = `POST_${commandType}`;
            return this[key] || [];
        };
        this.registerCommandPreviousHook = (commandType, fn) => {
            const key = `PREVIOUS_${commandType}`;
            if (!this[key]) {
                this[key] = [];
            }
            this[key].push(fn);
        };
        this.registerCommandPostHook = (commandType, fn) => {
            const key = `POST_${commandType}`;
            if (!this[key]) {
                this[key] = [];
            }
            this[key].push(fn);
        };
        this.getTabsCanvasData = () => {
            var _a;
            return (_a = this.tabsCanvasData) === null || _a === void 0 ? void 0 : _a.map(({ id, label, canvasData }) => {
                return {
                    id,
                    label,
                    canvasData: this.getCanvasData(id) || canvasData,
                };
            });
        };
        this.getCanvasData = (canvasId) => {
            var _a, _b;
            if (canvasId) {
                return (_a = this === null || this === void 0 ? void 0 : this.canvasIdModelMap[canvasId]) === null || _a === void 0 ? void 0 : _a.getCanvasData();
            }
            else {
                return (_b = this === null || this === void 0 ? void 0 : this.getActiveCanvasModel()) === null || _b === void 0 ? void 0 : _b.getCanvasData();
            }
        };
        this.consolePanelRef = {
            zIndex: 600,
        };
        this.setConsolePanelRef = (ref) => {
            Object.assign(this.consolePanelRef, ref);
        };
        this.getConsolePanelRef = () => {
            return this.consolePanelRef;
        };
        this.configPanelRef = {
            zIndex: 600,
        };
        this.setConfigPanelRef = (ref) => {
            Object.assign(this.configPanelRef, ref);
        };
        this.getConfigPanelRef = () => {
            return this.configPanelRef;
        };
        this.setContainerDom = (dom) => {
            this.containerDom = dom;
        };
        this.getContainerDom = () => {
            return this.containerDom;
        };
        this.globalState = {};
        this.globalDataEventQueue = [];
        this.triggerGlobalDataChange = () => {
            var _a;
            (_a = this['globalDataEventQueue']) === null || _a === void 0 ? void 0 : _a.forEach(fn => {
                fn === null || fn === void 0 ? void 0 : fn(this.getGlobalState());
            });
        };
        this.setGlobalState = (fn) => {
            const newGlobalState = fn(this.getGlobalState());
            if (!isEqual(this.globalState, newGlobalState)) {
                this.globalState = newGlobalState;
                this.triggerGlobalDataChange();
            }
        };
        this.getGlobalState = () => {
            return this.globalState;
        };
        this.onGlobalDataChange = (fn) => {
            this['globalDataEventQueue'].push(fn);
        };
        this.offGlobalDataChange = (fn) => {
            var _a;
            const idx = (_a = this['globalDataEventQueue']) === null || _a === void 0 ? void 0 : _a.findIndex(item => item === fn);
            this['globalDataEventQueue'].splice(idx, 1);
        };
        this.oFlowId = oFlowId;
    }
}
OFlowModel.oFlowIdConfigModelMap = {};
//# sourceMappingURL=index.js.map